"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [0, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_stripe_elements_1 = require("react-stripe-elements");

var index_1 = require("../index");

require("./payment.less");

var PaymentForm = function (_super) {
  __extends(PaymentForm, _super);

  function PaymentForm(props) {
    var _this = _super.call(this, props) || this;

    _this.onChange = _this.onChange.bind(_this);
    _this.state = {
      completed: {},
      inProgress: false
    };
    return _this;
  }

  PaymentForm.prototype.onChange = function (key, result) {
    var completed = this.state.completed;
    completed[key] = !!result.complete;
    this.setState({
      completed: completed
    });
  };

  PaymentForm.prototype.onAction = function (action) {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      var _a, _b, context, field, token;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _a = action;

            switch (_a) {
              case "submit":
                return [3
                /*break*/
                , 1];
            }

            return [3
            /*break*/
            , 3];

          case 1:
            _b = this.props, context = _b.context, field = _b.field;
            context.onValue("inProgress", true, true);
            this.setState({
              inProgress: true
            });
            return [4
            /*yield*/
            , this.props.stripe.createToken()];

          case 2:
            token = _c.sent();

            if (!!token["token"]) {
              context.onValue(field, token.token, true);
            } else {
              context.onValue(field, token.error, false);
              this.setState({
                inProgress: false
              });
            }

            setTimeout(function () {
              _this.setState({
                inProgress: false
              });
            }, 5000);
            return [3
            /*break*/
            , 4];

          case 3:
            console.error(action);
            _c.label = 4;

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentForm.prototype.onValue = function (field, value, isValid) {};

  PaymentForm.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        amount = _a.amount,
        currency = _a.currency;
    var symbol;

    switch (currency) {
      case "gbp":
      default:
        symbol = "£";
    }

    var inputStyle = {
      base: {
        fontSize: "14px",
        fontFamily: "'Nunito Sans', 'Avenir', 'Helvetica', 'Arial', sans-serif",
        lineHeight: "20px",
        color: "#2a2841",
        "::placeholder": {
          color: "#a4aab3"
        }
      },
      invalid: {
        color: "#fc4e6b"
      }
    };
    var buttonStyle = {
      fontSize: "14px",
      fontFamily: "'Nunito Sans', 'Avenir', 'Helvetica', 'Arial', sans-serif",
      lineHeight: "20px",
      color: "#ffffff",
      background: "linear-gradient(18deg, #5d5af3, #3f9df4)"
    };
    var completed = this.state.completed;
    var enableSubmit = completed.cardNumber && completed.expiry && completed.cvc && !this.state.inProgress;
    return React.createElement("form", null, React.createElement(index_1.Row, {
      collapsed: true
    }, React.createElement(index_1.Col, {
      xs: 12
    }, React.createElement(react_stripe_elements_1.CardNumberElement, {
      onChange: function onChange(r) {
        return _this.onChange("cardNumber", r);
      },
      style: inputStyle
    }))), React.createElement(index_1.Row, {
      collapsed: true
    }, React.createElement(index_1.Col, {
      xs: 6
    }, React.createElement(react_stripe_elements_1.CardExpiryElement, {
      onChange: function onChange(r) {
        return _this.onChange("expiry", r);
      },
      style: inputStyle
    })), React.createElement(index_1.Col, {
      xs: 6
    }, React.createElement(react_stripe_elements_1.CardCVCElement, {
      onChange: function onChange(r) {
        return _this.onChange("cvc", r);
      },
      style: inputStyle
    }))), React.createElement(index_1.Row, {
      collapsed: true
    }, React.createElement(index_1.Col, {
      xs: 12
    }, React.createElement("ul", {
      className: "payment methods"
    }, React.createElement("li", null, React.createElement("img", {
      className: "visa",
      src: "https://s3-eu-west-1.amazonaws.com/perfocal-asset/images/visa.png"
    })), React.createElement("li", null, React.createElement("img", {
      className: "mastercard",
      src: "https://s3-eu-west-1.amazonaws.com/perfocal-asset/images/mastercard.svg"
    })), React.createElement("li", null, React.createElement("img", {
      className: "amex",
      src: "https://s3-eu-west-1.amazonaws.com/perfocal-asset/images/american_express.png"
    })), React.createElement("li", null, React.createElement("img", {
      className: "stripe",
      src: "https://s3-eu-west-1.amazonaws.com/perfocal-asset/images/stripe.svg"
    }))))), React.createElement(index_1.Row, {
      collapsed: true
    }, React.createElement(index_1.Col, {
      xs: 12,
      md: 6,
      mdOffset: 3
    }, React.createElement(index_1.Button, {
      className: "btn--primary-gradient box-shadow-button",
      disabled: !enableSubmit,
      action: "submit",
      context: this
    }, "Pay ", symbol, amount / 100))));
  };

  return PaymentForm;
}(React.Component);

var Payment = react_stripe_elements_1.injectStripe(PaymentForm);
exports["default"] = Payment;